
import { Component, Injector } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mj_Detail } from '../mj_detail/mj_detail';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { HatComponent } from '../component/hat';
import { LancetsComponent } from '../component/lancets';
import { LineSvgComponent } from '../component/linesvg';
import { UserStarComponent } from '../component/userstar';
import { Confirm } from '../confirm/confirm';
import { Dashboard } from './../dashboard/dashboard';
import { ChangePassword } from '../changepassword/changepassword';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { TranslateService } from '@ngx-translate/core';
import { EthemeProvider } from '../../providers/etheme/etheme';
/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
/*@NgModule({
  imports: [RoundProgressModule]
})*/
var docsrc = '';
@Component({
  selector: 'page-profilo',
  templateUrl: 'profilo.html',
})
export class Profilo extends Util {
  pagine: any;
  user: any = {};
  mjl: any;
  page: string;
  getbg = { allena: {}, apprendi: {}, competenze: {}, shop: {} };
  params = { id: '', nome: '', cognome: '', email: '', username: '', data_nascita: '', azienda: '', area: '', filiale: '', ruolo: '', foto: '', cf: '', abilitato: 1 };
  percent_hat = '20%';
  imageURI: any;
  imageFileName: any;
  photoName: any;
  fileExtension: any;
  fileExtensionError: any;
  fileExtensionMessage: any;
  filesizeMessage: any;
  constructor(public navCtrl: NavController, public theme: EthemeProvider, public translate: TranslateService, public navParams: NavParams, injector: Injector, loading: LoadingController, hat: HatComponent, lancets: LancetsComponent, linesvg: LineSvgComponent, userstar: UserStarComponent, private transfer: FileTransfer, private file: File, private camera: Camera) {
    super(injector, loading);
    //this.user = this.navParams.get('user');
    ////console.log(this.user);
    this.page = 'dash';
    // this.storage.get('user').then((userdata) => {
    this.GetRequest('me', '', true, false).then((userdata) => {


      this.user = userdata['user'];
      //console.log(userdata);

      for (let key in this.params) {
        this.params[key] = userdata['user'][key];
      }
    });
    // })

  }


  elimina_account() {
    this.translate.get(['profilo.ELIMINAACCOUNT', 'profilo.ATTENZIONEELIMINAACCOUNT', 'profilo.SISONOSICURO','ANNULLA']).subscribe(v => {
      const alert = this.alertCtrl.create({
        title: v['profilo.ELIMINAACCOUNT'],
        subTitle:  v['profilo.ATTENZIONEELIMINAACCOUNT'],
        cssClass: 'eliminaaccount',
        buttons: [
          {
            text: v['ANNULLA'],
            role: 'cancel',
            cssClass: 'secondary',
            // handler: (blah) => {
            //   console.log('Confirm Cancel: blah');
            // }
          }, {
            text: v['profilo.SISONOSICURO'],
            cssClass: 'alertx',
            handler: () => {
              // console.log('Confirm Okay');
              this.elimina_account_def();
              // this.params.abilitato = 0;
              // this.salva();
              // setTimeout(() => {
              //   this.logout()
              // }, 1000);
            }
          }
        ]
      });

      alert.present();
    });
  }


  elimina_account_def() {
    this.translate.get(['profilo.ELIMINAACCOUNT', 'profilo.ATTENZIONEELIMINAACCOUNT2', 'profilo.SISONOSICURO2','ANNULLA']).subscribe(v => {
      const alert = this.alertCtrl.create({
        title: v['profilo.ELIMINAACCOUNT'],
        subTitle:  v['profilo.ATTENZIONEELIMINAACCOUNT2'],
        cssClass: 'eliminaaccount',
        buttons: [
          {
            text: v['ANNULLA'],
            role: 'cancel',
            cssClass: 'secondary',
            // handler: (blah) => {
            //   console.log('Confirm Cancel: blah');
            // }
          }, {
            text: v['profilo.SISONOSICURO2'],
            cssClass: 'alertx',
            handler: () => {
              // console.log('Confirm Okay');
              this.params.abilitato = 0;
              this.salva();
              setTimeout(() => {
                this.logout()
              }, 1000);
            }
          }
        ]
      });

      alert.present();
    });
  }


  getImage() {
    if (this.plt.is('cordova') && (this.plt.is('ios') || this.plt.is('android'))) {
      var buttons = [{ text: 'Fotocamera', icon: 'camera' }, { text: 'Galleria personale', icon: 'images' }];
      this.presentActionSheet('Scegli la sorgente della tua foto profilo', buttons).then((ris) => {
        if (ris == 0) {
          const options: CameraOptions = {
            quality: 50,
            destinationType: this.camera.DestinationType.DATA_URL,
            sourceType: this.camera.PictureSourceType.CAMERA,
            encodingType: this.camera.EncodingType.JPEG,
            mediaType: this.camera.MediaType.PICTURE
          };
          this.camera.getPicture(options).then((imageData) => {
            this.imageURI = imageData;

            var base64Image = 'data:image/jpeg;base64,' + imageData;
            this.sendimage(base64Image);
          }, (err) => {
            //console.log(err);
            //this.presentToast(err);
            console.error(err);
          });
        }
        else if (ris == 1) {
          const options: CameraOptions = {
            quality: 50,
            destinationType: this.camera.DestinationType.DATA_URL,
            sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
            encodingType: this.camera.EncodingType.JPEG,
            mediaType: this.camera.MediaType.PICTURE
          };
          this.camera.getPicture(options).then((imageData) => {
            this.imageURI = imageData;

            var base64Image = 'data:image/jpeg;base64,' + imageData;
            this.sendimage(base64Image);
          }, (err) => {
            //console.log(err);
            //this.presentToast(err);
            console.error(err);
          });
        }



      })



    }
    else {

    }
  }


  logout() {

    this.storage.get('user').then(user => {

      this.storage.get('tokenFCM').then((tokenfcm) => {
        if (tokenfcm != '' && tokenfcm != undefined && tokenfcm != null) {
          if (this.etheme.theme_selected == 'mygame-theme' ) {
            this.PostRequest('remove_device', '', { 'cliente': 'mygame', 'device': 'Android', 'tokenFCM': tokenfcm }, false, false).then((r) => {
        
            })
          }
          else if (this.etheme.theme_selected == 'dark-theme_' ) {
            this.PostRequest('remove_device', '', { 'cliente': 'eydlab', 'device': 'Android', 'tokenFCM': tokenfcm}, false, false).then((r) => {
        
            })
          }
          else if (this.etheme.theme_selected == 'yamamay-theme') {
            this.PostRequest('remove_device', '', { 'cliente': 'yamamay', 'device': 'Android', 'tokenFCM': tokenfcm}, false, false).then((r) => {
            
            })
          }
          else if (this.etheme.theme_selected == 'carrefour-theme' ) {
            this.PostRequest('remove_device', '', { 'cliente': 'carrefour', 'device': 'Android', 'tokenFCM': tokenfcm}, false, false).then((r) => {
             
            })
          }
          else if (this.etheme.theme_selected == 'noeinglese-theme' ) {
            this.PostRequest('remove_device', '', { 'cliente': 'noeformazione', 'device': 'Android', 'tokenFCM': tokenfcm}, false, false).then((r) => {
             
            })
          }
        }
      })
      if (user != undefined) {
        let webkit = (window as any).webkit;
        if (webkit != undefined) {
          webkit.messageHandlers.jsHandler.postMessage(JSON.stringify({
            method: "remove_device",
            data: {
              token: user.token,
              url: this.urlserver
            }
          }));
        }
      }

      this.cleardata();
    },
      error => {
        this.cleardata();
      });


  }

  cleardata() {
    this.storage.get('language').then((lan) => {
      var language = lan;
      this.storage.remove('user').then(() => {
        // this.storage.clear();
        this.storage.set('language', language).then((lan) => {
          if (this.etheme.theme_selected == 'sky-theme' || this.etheme.theme_selected == 'yamamay-theme' || this.etheme.theme_selected == 'carrefour-theme') {
            let url = document.URL;
            window.location.href = url.replace('?login=sso', '');
          }
          else
            window.location.reload();
          // window.location.reload();
        })
      });
    })

  }

  // logout() {


  //   this.storage.get('language').then((lan) => {
  //     var language = lan;
  //     this.storage.remove('user').then(() => {
  //       // this.storage.clear();
  //       this.storage.set('language', language).then((lan) => {
  //         window.location.reload();
  //       })
  //     });
  //   })
    
  // }


  back() {
    this.navCtrl.pop({ animate: false });
  }
  go_root() {
    this.navCtrl.setRoot(Dashboard);
  }
  salva() {
    this.PutRequest('utente', this.params.id, this.params).then((res) => {
      //console.log(res);

      for (let key in this.params) {
        for (let keyu in this.user)
          if (key == keyu)
            this.user[keyu] = this.params[key];
      }
      // this.storage.set('user', this.user);


    }).catch((e) => {
      console.error(e)
    })

  }
  cambia_password() {
    this.openModal(ChangePassword, {}).then((res) => {
      //console.log(res);
    })
  }


  onChange(f) {

    var file = f[0];
    if (file != undefined) {
      this.photoName = file.name;

      var allowedExtensions =
        ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG"];
      this.fileExtension = this.photoName.split('.').pop();
      this.translate.get(['profilo.ERROREFILE', 'profilo.ERRAMMESSEIMG', 'profilo.ERRDIMENSIONE']).subscribe(v => {
        if (allowedExtensions.indexOf(this.fileExtension) == -1) {
          this.showBasicAlert(v['profilo.ERROREFILE'], v['profilo.ERRAMMESSEIMG']);
          return;
        }
        if (file.size > 2024000) {
          this.showBasicAlert(v['profilo.ERROREFILE'], v['profilo.ERRDIMENSIONE'])
          return;
        }
      })
    }
    if (file) {
      var reader = new FileReader();
      reader.onload = () => {
        //reader.result - base64

        this.sendimage(reader.result);

      }
      // reader.onload = function () {  
      // };
      if (f[0]) {
        reader.readAsDataURL(f[0]);
      }
      reader.onerror = function (error) {
        //console.log("Failed to load file");
      };
    }
    else {

      //console.log("Failed to load file");
    }
  }


  sendimage(base) {
    this.PutRequest('fotoProfilo', this.params.id, { base64: base }, true, true).then((res) => {
      //console.log(res);
      this.user.foto = res['path'];
      this.params.foto = res['path'];
      // this.storage.set('user', this.user);
    }).catch((err) => {
      console.error(err);
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/profilo/profilo.ts